
import MY_CONFIG from "@/constants";
import {
  Mail,
  Globe,
  MessageCircle,
  Shield,
  CircleHelp,
} from "lucide-react";

export default function SupportPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto px-6 py-16">

        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold">
            {MY_CONFIG.APP_NAME.toUpperCase()} Support
          </h1>

          <p className="mt-4 text-gray-600">
            Need help using {MY_CONFIG.APP_NAME}? We're here to assist.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">

          <div className="bg-white rounded-2xl p-6 shadow-sm border">
            <Mail className="w-8 h-8 text-blue-600 mb-3" />

            <h2 className="font-semibold text-xl mb-2">
              Contact Support
            </h2>

            <p className="text-gray-600 mb-4">
              Reach out to us for technical issues, feedback, or suggestions.
            </p>

            <a
              href="mailto:support@gazette.mv"
              className="text-blue-600 font-medium"
            >
              {MY_CONFIG.EMAIL}
            </a>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm border">
            <Globe className="w-8 h-8 text-green-600 mb-3" />

            <h2 className="font-semibold text-xl mb-2">
              Website
            </h2>

            <p className="text-gray-600 mb-4">
              Visit our official website.
            </p>

            <a
              href={MY_CONFIG.PUBLIC_DOMAIN}
              target="_blank"
              className="text-green-600 font-medium"
            >
              {MY_CONFIG.PUBLIC_DOMAIN}
            </a>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm border">
            <CircleHelp className="w-8 h-8 text-purple-600 mb-3" />

            <h2 className="font-semibold text-xl mb-2">
              Frequently Asked Questions
            </h2>

            <ul className="space-y-2 text-gray-600">
              <li>• How do I search announcements?</li>
              <li>• How do I save announcements?</li>
              <li>• Why is an announcement unavailable?</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm border">
            <Shield className="w-8 h-8 text-red-600 mb-3" />

            <h2 className="font-semibold text-xl mb-2">
              Privacy
            </h2>

            <p className="text-gray-600">
                {MY_CONFIG.APP_NAME} does not sell personal information and only stores data necessary for app functionality.
            </p>
          </div>

        </div>

        <div className="mt-12 text-center text-gray-500">
          © 2026 {MY_CONFIG.APP_NAME}. All rights reserved.
        </div>
      </div>
    </div>
  );
}